import {
  CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST,
  CARD_MERCHANT_SETTLEMENT_DETAIL_CLEAN_REQUEST,
  CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST,
  CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE,
  CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS,
  CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST,
  CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE,
  CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_ADD_REQUEST,
  CARD_SETTLEMENT_ADD_REQUEST_FAILURE,
  CARD_SETTLEMENT_ADD_REQUEST_SUCCESS,
  CARD_SETTLEMENT_CLEAN_REQUEST,
  CARD_SETTLEMENT_FETCH_REQUEST,
  CARD_SETTLEMENT_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_GROUP_BY_CLEAN_REQUEST,
  CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST,
  CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_MCC_CLEAN_REQUEST,
  CARD_SETTLEMENT_MCC_FETCH_REQUEST,
  CARD_SETTLEMENT_MCC_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_MCC_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_UPDATE_REQUEST,
  CARD_SETTLEMENT_UPDATE_REQUEST_FAILURE,
  CARD_SETTLEMENT_UPDATE_REQUEST_SUCCESS,
  FILTER_FIELD_CLEAN_REQUEST,
  FILTER_FIELD_FETCH_REQUEST,
  FILTER_FIELD_FETCH_REQUEST_FAILURE,
  FILTER_FIELD_FETCH_REQUEST_SUCCESS,
  SETTLE_CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST,
  SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST,
  SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE,
  SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS,
  UPLOAD_SETTLEMENT_REQUEST,
  UPLOAD_SETTLEMENT_REQUEST_SUCCESS,
  UPLOAD_SETTLEMENT_REQUEST_FAILURE,
  CARD_SETTLEMENT_REPORT_FETCH_REQUEST,
  CARD_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_REPORT_CLEAN_REQUEST,
  CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST,
  CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_REPORT_SUMMARY_CLEAN_REQUEST,
  CARD_SETTLEMENT_REPORT_SUMMARY_LIST_CLEAN_REQUEST,
  CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST,
  CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST,
  CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_SUCCESS,
  CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_FAILURE,
  CARD_SETTLEMENT_REPORT_BATCH_LIST_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE_DROPDOWN = {
  payload: [],
  loading: false,
  errors: {},
};

const CARD_SETTLEMENT_DETAIL_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const CARD_MERCHANT_SETTLEMENT_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const CARD_SETTLEMENT_REPORT_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
    nextCursorId: null,
  },
};
const CARD_SETTLEMENT_REPORT_BATCH_LIST_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
    nextCursorId: null,
  },
};

const CARD_MERCHANT_SETTLEMENT_DETAIL_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const CARD_SETTLEMENT_REPORT_SUMMARY_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const CARD_SETTLEMENT_REPORT_SUMMARY_LIST_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

export const cardSettlementReducer = (state, action) => {
  state = state || CARD_SETTLEMENT_DETAIL_INITIAL_STATE;
  switch (action.type) {
    case CARD_SETTLEMENT_ADD_REQUEST:
    case CARD_SETTLEMENT_FETCH_REQUEST:
    case CARD_SETTLEMENT_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_SETTLEMENT_ADD_REQUEST_SUCCESS:
    case CARD_SETTLEMENT_FETCH_REQUEST_SUCCESS:
    case CARD_SETTLEMENT_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          totalPage: action.data.totalPage,
          total: action.data.totalRecord,
          showSizeChanger: true,
        },
      });

    case CARD_SETTLEMENT_ADD_REQUEST_FAILURE:
    case CARD_SETTLEMENT_FETCH_REQUEST_FAILURE:
    case CARD_SETTLEMENT_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case UPLOAD_SETTLEMENT_REQUEST:
    case UPLOAD_SETTLEMENT_REQUEST_SUCCESS:
    case UPLOAD_SETTLEMENT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    default:
      return state;
  }
};

export const cardSettlementGroupByReducer = (state, action) => {
  state = state || INITIAL_STATE_DROPDOWN;
  switch (action.type) {
    case CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case CARD_SETTLEMENT_GROUP_BY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_GROUP_BY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

export const cardSettlementMccDropdownReducer = (state, action) => {
  state = state || INITIAL_STATE_DROPDOWN;
  switch (action.type) {
    case CARD_SETTLEMENT_MCC_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_SETTLEMENT_MCC_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case CARD_SETTLEMENT_MCC_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_MCC_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

//cardSettlement merchant settlement

export const merchantCardSettlementDropdownReducer = (state, action) => {
  state = state || INITIAL_STATE_DROPDOWN;
  switch (action.type) {
    case FILTER_FIELD_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case FILTER_FIELD_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case FILTER_FIELD_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case FILTER_FIELD_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

export const merchantCardSettlementReducer = (state, action) => {
  state = state || CARD_MERCHANT_SETTLEMENT_INITIAL_STATE;
  switch (action.type) {
    case CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          totalPage: action.data.totalPage,
          total: action.data.totalRecord,
          showSizeChanger: true,
        },
      });

    case CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    default:
      return state;
  }
};
export const cardSettlementReportReducer = (state, action) => {
  state = state || CARD_SETTLEMENT_REPORT_INITIAL_STATE;
  switch (action.type) {
    case CARD_SETTLEMENT_REPORT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload:
          action.data.currentPage > 1
            ? [...state.payload, ...action.data.data]
            : [...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          nextCursorId: action.data.nextCursorId,
          showSizeChanger: true,
        },
      });

    case CARD_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_REPORT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });
    default:
      return state;
  }
};
export const cardSettlementReportBatchListReducer = (state, action) => {
  state = state || CARD_SETTLEMENT_REPORT_BATCH_LIST_INITIAL_STATE;
  switch (action.type) {
    case CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload:
          action.data.currentPage > 1
            ? [...state.payload, ...action.data.data]
            : [...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          nextCursorId: action.data.nextCursorId,
          showSizeChanger: true,
        },
      });

    case CARD_SETTLEMENT_REPORT_BATCH_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_REPORT_BATCH_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });
    default:
      return state;
  }
};

export const merchantCardSettlementDetailsReducer = (state, action) => {
  state = state || CARD_MERCHANT_SETTLEMENT_DETAIL_INITIAL_STATE;
  switch (action.type) {
    case CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST:
    case SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS:
    case SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          totalPage: action.data.totalPage,
          total: action.data.totalRecord,
          showSizeChanger: true,
        },
      });

    case CARD_MERCHANT_SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE:
    case SETTLE_CARD_MERCHANT_SETTLEMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_MERCHANT_SETTLEMENT_DETAIL_CLEAN_REQUEST:
    case SETTLE_CARD_MERCHANT_SETTLEMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    default:
      return state;
  }
};

export const cardSettlementReportDraftSummaryReducer = (state, action) => {
  state = state || CARD_SETTLEMENT_REPORT_SUMMARY_INITIAL_STATE;
  switch (action.type) {
    case CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          totalPage: action.data.totalPage,
          total: action.data.totalRecord,
          showSizeChanger: true,
        },
      });

    case CARD_SETTLEMENT_REPORT_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_REPORT_SUMMARY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    default:
      return state;
  }
};
export const cardSettlementReportDraftSummaryListReducer = (state, action) => {
  state = state || CARD_SETTLEMENT_REPORT_SUMMARY_LIST_INITIAL_STATE;
  switch (action.type) {
    case CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          totalPage: action.data.totalPage,
          total: action.data.totalRecord,
          showSizeChanger: true,
        },
      });

    case CARD_SETTLEMENT_REPORT_SUMMARY_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CARD_SETTLEMENT_REPORT_SUMMARY_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    default:
      return state;
  }
};
